import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button
} from '@material-ui/core';

const PipelineComponent = ({ map, maps, pipelineData, strokeColor, visible }) => {
  const [polylines, setPolylines] = useState([]);
  const [selectedPipeline, setSelectedPipeline] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);

  useEffect(() => {
  if (!visible || !map || !maps || !pipelineData) return;

  // Clear old
  polylines.forEach(p => p.setMap(null));
  setPolylines([]);

  const newPolylines = pipelineData.features.map(feature => {
    if (feature.geometry?.type === 'LineString') {
      const path = feature.geometry.coordinates.map(([lng, lat]) => ({ lat, lng }));
      const polyline = new maps.Polyline({
        path,
        strokeColor: strokeColor || '#FF0000',
        strokeOpacity: 1,
        strokeWeight: 2,
        zIndex: 2,
        map: map
      });

      polyline.addListener('mouseover', () => polyline.setOptions({ strokeWeight: 4 }));
      polyline.addListener('mouseout', () => polyline.setOptions({ strokeWeight: 2 }));
      polyline.addListener('click', () => {
        setSelectedPipeline(feature);
        setOpenDialog(true);
      });

      return polyline;
    }
    return null;
  });

  setPolylines(newPolylines.filter(Boolean));
}, [map, maps, pipelineData, strokeColor, visible]);


  useEffect(() => {
    // Update visibility
    polylines.forEach(p => p.setMap(visible ? map : null));
  }, [visible, map, polylines]);

  return (
    <>
      <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
        <DialogTitle>Pipeline Information</DialogTitle>
        <DialogContent>
          {selectedPipeline && (
            <>
              <p><strong>Operator:</strong> {selectedPipeline.properties?.opername || 'N/A'}</p>
              <p><strong>Pipeline:</strong> {selectedPipeline.properties?.pipename || 'N/A'}</p>
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialog(false)} color="primary">Close</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default PipelineComponent;
